<template>
    <div style="height: 100%;">
        <div class="tab-key-box">
            <div class="tab-key-item" @click="handleClick(item.value)" v-for="(item, index) in examineOptions"
                :key="index" :class="{ 'tab-active': activeName == item.value }">{{ item.label }}</div>
        </div>
        <div class="content-box-container">
            <theory ref="theory_test" :isDetail="isDetail" v-show="activeName == '1'"></theory>
            <virtual ref="virtual_test" :isDetail="isDetail" v-show="activeName == '2'"></virtual>
            <div class="btn-box" v-if="activeName == '2'&&!isDetail">
                <div class="save" v-debounce="save">保存</div>
            </div>
        </div>
    </div>
</template>

<script>
import Theory from './Theory.vue'
import Virtual from './Virtual.vue'
import { SaveExamine, UpdateExamine } from '@/api/examine';
export default {
    props: ['examineId','isDetail'],
    components: { Theory, Virtual },
    data() {
        return {
            activeName: '1',
            id:'',
            examineOptions: [
                {
                    label: '理论试卷',
                    value: '1'
                },
                {
                    label: '虚仿软件',
                    value: '2'
                },
            ]
        }
    },
    methods: {
        handleClick(val) {
            this.activeName = val
        },
        saveExamine(params) {
            return new Promise(resolve => {
                SaveExamine(params).then(res => {
                    if (res.code == 200) {
                        this.id=res.data;
                        resolve(res);
                    }
                })
            })
        },
        updateExamine(params) {
            return new Promise(resolve => {
                UpdateExamine(params).then(res => {
                    if (res.code == 200) {
                        this.id=res.data;
                        resolve(res);
                    }
                })
            })
        },
        /**校验 */
        verification(data){
            let obj={
                examineName:"考核名称不能为空",
                beginTime:'开始时间不能为空' ,
                endTime:'结束时间不能为空',
                answerTime:'答题时间不能为空',
                fullScore:'满分不能为空',
                passScore:'合格分不能为空',
            };
            for(let key in obj){
                if(!data[key]){
                    this.$msg({
                        showClose: true,
                        message: obj[key],
                        type: "warning",
                    });
                    return false;
                }
            }
            if(data.passScore>data.fullScore){
                this.$msg({
                    showClose: true,
                    message: "合格分必须小于等于满分",
                    type: "warning",
                });
                return false;
            }
            if(!data.refClassIds||data.refClassIds.length==0){
                this.$msg({
                    showClose: true,
                    message: "请选择班级",
                    type: "warning",
                });
                return false;
            }
            for(let item of data.refResourceDetails){
                if(item.resourceType==0&&!item.scoreRatio){
                    this.$msg({
                        showClose: true,
                        message: "理论分数占比必须大于0",
                        type: "warning",
                    });
                    return false;
                }
            }
            return true;
        },
        /**保存 */
        save() {
            let dom = this.$refs.theory_test;
            let dom1 = this.$refs.virtual_test;
            if (dom && dom1) {
                Promise.all([dom.save(), dom1.saveExamine()]).then(async (res) => {
                    let params1 = JSON.parse(JSON.stringify(res[0]));
                    let params2 = JSON.parse(JSON.stringify(res[1]));
                    const merged = Object.assign({}, params1, params2);
                    merged.refResourceDetails = [...params1.refResourceDetails, ...params2.refResourceDetails];
                    if(!this.verification(merged))return;
                    if (this.examineId) {
                        merged.id = this.examineId;
                        await this. updateExamine(merged);
                    } else {
                        await this.saveExamine(merged);
                    }
                    if (dom.form.extract == 'paper') {
                        dom.batchExcludeQuestion(this.id);
                    };
                    this.$msg({
                        showClose: true,
                        message: "新增考核成功",
                        type: "success",
                    });
                    this.$store.commit('course/changeOperation', '');
                    this.$store.commit('backend/changeOptlabel', '');
                    this.$emit('examine_success');
                })
            }
        }
    },
}
</script>

<style lang="less" scoped>
.tab-key-box {
    display: flex;
    background: #ffffff;
    border: 1px solid #e8ecef;
    border-radius: 1rem;
    box-shadow: 0px 0px 2.9rem 0px rgba(180, 190, 220, 0.30);
    width: 14rem;
    height: 4rem;

    .tab-key-item {
        width: 50%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        color: var(--blue);
        cursor: pointer;
    }

    &> :nth-child(1) {
        border-top-left-radius: 1rem;
        border-bottom-left-radius: 1rem;
        transition: all 0.3s;
    }

    &> :nth-child(2) {
        border-top-right-radius: 1rem;
        border-bottom-right-radius: 1rem;
        transition: all 0.3s;
    }
}

.table-key-box {
    height: calc(100% - 7.2rem);
    margin-top: 2.2rem;
}

.tab-active {
    color: #ffffff !important;
    background-color: var(--blue) !important;
}

.content-box-container {
    margin-top: 2rem;
    height: calc(100% - 6rem);
}

.btn-box {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 2.5rem;

    .save {
        width: 8.8rem;
        height: 4rem;
        background-color: var(--blue);
        border-radius: 0.8rem;
    }
}
</style>